export default __webpack_public_path__ + "static/media/Broadform Building Key Information Document 1 April 2023.de22b1da.pdf";